import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { TickerBar } from './TickerBar';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { CartSidebar } from '../cart/CartSidebar';
import { CheckoutModal } from '../checkout/CheckoutModal';
import { OrderSuccess } from '../checkout/OrderSuccess';

export function Layout() {
  const { setCartOpen, clearCart } = useCart();
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [successOrderId, setSuccessOrderId] = useState(null);

  // Recover payments where the page reloaded mid-flow (mobile UPI redirect / tab kill)
  useEffect(() => {
    let raw;
    try { raw = localStorage.getItem('kiane_pending_order'); } catch { return; }
    if (!raw) return;
    let pending;
    try { pending = JSON.parse(raw); } catch { try { localStorage.removeItem('kiane_pending_order'); } catch {} return; }
    // Discard entries older than 30 minutes — avoids stale recovery wiping a new cart
    if (!pending.savedAt || Date.now() - pending.savedAt > 30 * 60 * 1000) {
      try { localStorage.removeItem('kiane_pending_order'); } catch {}
      return;
    }
    fetch('/api/verify-payment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderId: pending.orderId, cfOrderId: pending.cfOrderId }),
    })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        try { localStorage.removeItem('kiane_pending_order'); } catch {}
        if (data?.success) { clearCart(); setSuccessOrderId(pending.orderId); }
      })
      .catch(() => { try { localStorage.removeItem('kiane_pending_order'); } catch {} });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="App">
      <TickerBar />
      <Navbar />
      <CartSidebar onCheckout={() => { setCartOpen(false); setCheckoutOpen(true); }} />
      {checkoutOpen && (
        <CheckoutModal
          onClose={() => setCheckoutOpen(false)}
          onSuccess={(id) => { setCheckoutOpen(false); setSuccessOrderId(id); }}
        />
      )}
      {successOrderId && (
        <OrderSuccess orderId={successOrderId} onClose={() => setSuccessOrderId(null)} />
      )}
      <Outlet />
      <Footer />
    </div>
  );
}
